// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"2af2ec38","453":"5214e719","732":"f3af6a93"}[chunkId] + ".chunk.js";
};